export const siteInfo = {
  name: '蜜桃成熟时',
  tagline: '经典港片深度解析平台',
  description: '蜜桃成熟时电影是香港经典情色喜剧代表作，本网站深度解析蜜桃成熟时电影的剧情、演员阵容、拍摄背景及文化影响，带您重温这部90年代港片的独特魅力与时代价值。',
  keywords: '蜜桃成熟时电影,蜜桃成熟时剧情介绍,蜜桃成熟时演员表,香港经典情色电影,90年代港片推荐,蜜桃成熟时完整版,香港三级片经典回顾',
  url: 'https://luxd168.cn',
  logo: '蜜桃成熟时',
  foundingYear: 2023,
  email: 'contact@mitaochengshushi.com',
  phone: '+852 1234 5678',
  address: '香港九龙尖沙咀弥敦道100号',
  socialLinks: {
    weibo: 'https://weibo.com/mitaochengshushi',
    wechat: 'mitaochengshushi',
    douban: 'https://movie.douban.com/subject/',
  },
};